/**
 * @generated SignedSource<<09906b360b52a6b555e60ca8be05c9a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SitemapWrapper_viewer$data = {
  readonly sitemap: {
    readonly " $fragmentSpreads": FragmentRefs<"SitemapNested_sitemap" | "SitemapValueType_sitemap">;
  } | null;
  readonly " $fragmentType": "SitemapWrapper_viewer";
};
export type SitemapWrapper_viewer$key = {
  readonly " $data"?: SitemapWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SitemapWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "filterType"
    },
    {
      "kind": "RootArgument",
      "name": "filterTypeValue"
    },
    {
      "kind": "RootArgument",
      "name": "level"
    },
    {
      "kind": "RootArgument",
      "name": "pageNumber"
    },
    {
      "kind": "RootArgument",
      "name": "vertical"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SitemapWrapper_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filterType",
          "variableName": "filterType"
        },
        {
          "kind": "Variable",
          "name": "filterTypeValue",
          "variableName": "filterTypeValue"
        },
        {
          "kind": "Variable",
          "name": "level",
          "variableName": "level"
        },
        {
          "kind": "Variable",
          "name": "pageNumber",
          "variableName": "pageNumber"
        },
        {
          "kind": "Variable",
          "name": "vertical",
          "variableName": "vertical"
        }
      ],
      "concreteType": "Sitemap",
      "kind": "LinkedField",
      "name": "sitemap",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SitemapNested_sitemap"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SitemapValueType_sitemap"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b7fe3ff93ebf3f8c8d8c1c0e1e57f1e4";

export default node;
